import { render, staticRenderFns } from "./citySelect.vue?vue&type=template&id=2652430a&scoped=true"
import script from "./citySelect.vue?vue&type=script&lang=js"
export * from "./citySelect.vue?vue&type=script&lang=js"
import style0 from "./citySelect.vue?vue&type=style&index=0&id=2652430a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652430a",
  null
  
)

export default component.exports